const step = (selector, title, description) => ({ selector, title, description });

export const interfaceGuides = {
  '/dashboard': {
    name: 'Accueil',
    steps: [
      step('[data-tour="project"]', 'Projet actif', 'Consultez le projet affiché et changez de projet si vous en suivez plusieurs.'),
      step('[data-tour="navigation"]', 'Navigation', 'Accédez aux tickets, aux tests à valider, aux livraisons et à la documentation.'),
      step('[data-tour="indicators"]', 'Indicateurs du projet', 'Consultez les User Stories, les Story Points et les heures estimées.'),
      step('[data-tour="progress"]', 'Avancement et actions', 'Suivez les livraisons et ouvrez les User Stories qui demandent votre attention.'),
      step('[data-tour="milestones"]', 'Jalons', 'Visualisez les échéances et la progression des jalons du projet.'),
    ],
  },
  '/team-tv': {
    name: 'Écran équipe',
    steps: [
      step('.tv-presence', 'Équipe et disponibilités', 'Consultez la présence des collègues et leurs moyens de contact.'),
      step('.tv-agenda', 'Agenda du jour', 'Retrouvez les réunions et événements de l’équipe.'),
      step('.tv-operations', 'Activité du sprint', 'Suivez le sprint et les tickets reçus par l’assistance.'),
      step('.tv-milestones', 'Prochains jalons', 'Repérez les échéances et leurs responsables.'),
    ],
  },
  '/dashboard/tickets': {
    name: 'Assistance',
    steps: [
      step('.horizon-header-actions .assistance-primary, .assistance-bot-button', 'Demander de l’aide', 'Créez un ticket ou décrivez votre demande à Dynamix.'),
      step('.assistance-status-overview', 'Statut des tickets', 'Voyez combien de demandes sont nouvelles, en cours ou résolues.'),
      step('.assistance-toolbar', 'Recherche et filtres', 'Recherchez un ticket et changez de vue selon son état.'),
      step('.assistance-ticket-table, .assistance-empty', 'Liste des tickets', 'Ouvrez un ticket pour consulter les échanges et son suivi.'),
      {
        ...step('.assistance-confirmation-list', 'Clôturer un ticket résolu', 'Dans « Ouverts », les tickets résolus apparaissent dans « À confirmer par vous ». Cliquez sur « Voir l’échange » pour vérifier la réponse, puis sur « Clôturer » et confirmez. Le ticket passe dans « Clôturés ».'),
        fallbackSelector: '.assistance-status--resolved',
      },
    ],
  },
  '/dashboard/ticket-situation': {
    name: 'Situation des tickets',
    steps: [
      step('.ticket-situation__views', 'Vues rapides', 'Passez d’une étape du projet à une autre.'),
      step('.ticket-situation__filter-toggle', 'Filtres', 'Affinez les résultats par date, Story Points ou autre critère.'),
      step('.ticket-list', 'User Stories', 'Ouvrez une ligne pour consulter son détail et les actions disponibles.'),
    ],
  },
  '/dashboard/client-testing': {
    name: 'Tests à valider',
    steps: [
      step('.testing-state-views', 'État des tests', 'Passez des tests à faire aux corrections et aux tests validés.'),
      step('.testing-filter-toggle', 'Filtres des tests', 'Affichez les filtres pour trouver les tests qui vous concernent.'),
      step('.testing-list', 'User Stories à vérifier', 'Ouvrez un test pour lire ses critères et enregistrer votre retour.'),
    ],
  },
  '/dashboard/milestone-stories': {
    name: 'User Stories du jalon',
    steps: [
      step('.client-story-header', 'Jalon sélectionné', 'Retrouvez le jalon et le nombre de User Stories associées.'),
      step('.client-content input[placeholder="Rechercher par titre ou code..."]', 'Recherche', 'Cherchez une User Story par titre ou par code.'),
      step('.client-content', 'Liste du jalon', 'Consultez les User Stories et ouvrez leur détail.'),
    ],
  },
  '/dashboard/deploiements': {
    name: 'Déploiements',
    steps: [
      step('.deployment-toolbar', 'Filtres des déploiements', 'Filtrez par environnement ou recherchez une mise en ligne.'),
      step('.deployment-records', 'Historique', 'Parcourez les déploiements et ouvrez une entrée pour voir ses informations.'),
    ],
  },
  '/dashboard/livraisons': {
    name: 'Livraisons',
    steps: [
      step('.delivery-toolbar', 'Filtres des livraisons', 'Filtrez par signature ou recherchez une livraison.'),
      step('.delivery-records', 'Livraisons du projet', 'Ouvrez une livraison pour consulter son contenu et sa signature.'),
    ],
  },
  '/dashboard/documentation': {
    name: 'Documentation',
    steps: [
      step('.dashboard-route-stage aside', 'Choix du projet', 'Sélectionnez le projet dont vous souhaitez lire les guides.'),
      step('.dashboard-route-stage main', 'Guide et versions', 'Choisissez une version, puis parcourez le guide fonctionnel.'),
    ],
  },
  '/dashboard/sprint': {
    name: 'Analyse Sprint',
    steps: [
      step('.dashboard-route-stage h1', 'Sprint actif', 'Consultez l’analyse globale ou sélectionnez un projet.'),
      step('.dashboard-route-stage [data-tour="sprint-charts"]', 'Progression du sprint', 'Suivez la charge restante et le pipeline de Story Points.'),
      step('.dashboard-route-stage [data-tour="sprint-team"]', 'Progression par client', 'Comparez l’avancement des clients et de l’équipe.'),
    ],
  },
  '/dashboard/analytics': {
    name: 'Vue opérationnelle',
    steps: [
      step('.dashboard-route-stage h1', 'Vue opérationnelle', 'Filtrez les analyses par projet depuis l’en-tête.'),
      step('.dashboard-route-stage [data-tour="analytics-health"]', 'Santé et support', 'Consultez la santé des projets, les tickets et le pipeline.'),
      step('.dashboard-route-stage [data-tour="analytics-work"]', 'Travail à suivre', 'Repérez le raffinage, les estimations et les tests.'),
    ],
  },
  '/dashboard/team-performance': {
    name: 'Performance équipe',
    steps: [
      step('.dashboard-route-stage header', 'Période et projet', 'Choisissez la période et le projet à analyser.'),
      step('.dashboard-route-stage section:first-of-type', 'Flux de livraison', 'Repérez les étapes où le travail ralentit.'),
      step('.dashboard-route-stage section:nth-of-type(2)', 'Indicateurs', 'Consultez la vélocité, le refaisage et les délais de validation.'),
    ],
  },
  '/dashboard/chatbot': {
    name: 'Dynamix',
    steps: [
      step('.client-chat', 'Assistant Dynamix', 'Posez une question sur votre projet ou choisissez une suggestion.'),
      step('.client-chat form', 'Votre question', 'Saisissez votre demande puis envoyez-la à l’assistant.'),
    ],
  },
};

export const getInterfaceGuide = pathname => interfaceGuides[pathname] || null;
